import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrderAdminRepository from "../../../../repository/Admin/OrderAdminRepository";

export const getAdminOrderInsightList = createAsyncThunk('get_admin_order_insight_list', async (params) => {
  return await new OrderAdminRepository().getAdminOrderInsightList(params);
});

const slice = createSlice({
  name: "OrdersInsightList",
  initialState: {
    orderInsightList: [],
    totalRecords: 0,
    filteredRecords: 0,
    orderTotal:0
  },
  reducers: {
    setAdminOrderInsightList: {
      reducer: (state, action) => {
        state.adminOrderInsightInfo = action.payload;
        return state;
      },
    },
  },
  extraReducers: {
    [getAdminOrderInsightList.fulfilled]: (state, action) => {
      state.orderInsightList = action.payload?.adminOrderDetails;
      state.totalRecords = action.payload?.totalLineItemCount;
      state.orderTotal=action.payload?.orderTotal;
    },
  },
});

export const { setAdminOrderInsightList } = slice.actions;

export default slice.reducer;